import { createRoute } from "../../utils";

import { studentRoutesObj, studentBreadcrumbs } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { IRole } from "@/interfaces";

const permission = [IRole.FACULTY_MEMBER];

const studentsRouteMetadata: IRouteMetadataObj<typeof studentRoutesObj> = {
  list: {
    title: "studentsManagement",
    lazy: () => import("@/pages/facultyMemberPanel/student/table/page"),
    mode: "index",
    permission,
  },
  create: {
    title: "addNewStudent",
    lazy: () => import("@/pages/facultyMemberPanel/student/form/page"),
    mode: "create",
    permission,
  },
  edit: {
    title: "editStudentOf",
    lazy: () => import("@/pages/facultyMemberPanel/student/form/page"),
    mode: "edit",
    permission,
  },
  view: {
    title: "viewStudentOf",
    lazy: () => import("@/pages/facultyMemberPanel/student/form/page"),
    mode: "view",
    permission,
  },
};

export const studentRoutes = createRoute<typeof studentRoutesObj>(
  studentRoutesObj,
  studentsRouteMetadata,
  studentBreadcrumbs,
);
